// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { headerHeightSelector } from "@store/Framework/Store/Bunzl/Components/Header/HeaderSelectors";
import { HeaderHeightParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import useDispatchHeaderHeight from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useDispatchHeaderHeight";

export default () => {
    const headerHeight = useAppSelector(state => headerHeightSelector(state));
    const dispatchHeaderHeight = useDispatchHeaderHeight();

    return {
        headerHeight,
        setHeaderHeight: (height: HeaderHeightParameter) => {
            dispatchHeaderHeight(height);
        },
    };
};
